var map = {
	"./basketball-active.webp": 1461,
	"./basketball.webp": 1462,
	"./bg.webp": 1463,
	"./football-active.webp": 1464,
	"./football.webp": 1465,
	"./games-active.webp": 1466,
	"./games.webp": 1467,
	"./information.webp": 1468,
	"./live-streaming-cover.webp": 1469,
	"./lv-active-bg.webp": 1470,
	"./video-bg.webp": 1471,
	"./video-icon.webp": 1472,
	"./vs.webp": 1473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;